import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,  
} from "@mui/material";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import GCAutocompleteCheckboxFixSizeUid
  from "../VendorDiscontinueChangeApprove/GCAutocompleteCheckboxFixSizeUid";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import moment from "moment";

const RSPRejectReport = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
   const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const [filterObj, setFilterObj] = useState({
    dateFrom: moment().startOf("month").toDate(),
    dateTo: moment().toDate(),
    location: [],
  });

  const [reportUrl, setReportUrl] = useState(""); // For inline report
  const [Location, setLocation] = useState([]);
  const [initialized, setInitialized] = useState(false);
   const [reportModalOpen, setReportModalOpen] = useState(false);

  // Populate Location from Redux
  useEffect(() => {
    setLocation(vRdxuserLoc || []);
  }, [vRdxuserLoc]);

  // Set default selected locations only once
  useEffect(() => {
    if (Location?.length > 0 && !initialized) {
      const allLocationCodes = Location.map((item) => item.Uid);
      setFilterObj((prev) => ({
        ...prev,
        location: allLocationCodes,
      }));
      setInitialized(true);
    }
  }, [Location, initialized]);

  // Handle View Report button
  const handleViewReport = () => {
    const url = `${
      vRdxDBKernObj?.WEB_REPORT_BASE_URL?.DefVal ?? ""
    }wms/RSPchanges?prntyp=${filterObj?.reportType}&P_FromDate=${
      moment(filterObj?.dateFrom).format("MM/DD/YYYY") ?? ""
    }&P_ToDate=${moment(filterObj?.dateTo).format("MM/DD/YYYY") ?? ""}&P_Loc=${
      filterObj?.location.join(",") ?? ""
    }`;
    console.log("RSP reject report url", url);
    setReportUrl(url);
      if (isMobile) {
      setReportModalOpen(true);
    }
  };
console.log(filterObj);

 return (
    <Box p={2} display="flex" gap={2}>
      {/* Filters Panel */}
      <Paper
        elevation={3}
        sx={{
          width: { xs: 500,sm:200, md: 300 },
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "90vh",
        }}
      >
        <Typography variant="h6">Filters</Typography>

        {/* Date Range */}
        <Box>
          <Typography>From</Typography>
          <CmpDatePickerField001V1
           xLabelText=""
            xName="dateFrom"
            xValue={filterObj.dateFrom}
            xOnChange={(val) =>
              setFilterObj((prev) => ({
                ...prev,
                dateFrom: val?.$d ?? val,
              }))
            }
          />
        </Box>
        <Box>
          <Typography>To</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName="dateTo"
            xValue={filterObj.dateTo}
            xOnChange={(val) =>
              setFilterObj((prev) => ({
                ...prev,
                dateTo: val?.$d ?? val,
              }))
            }
          />
        </Box>

        {/* Location */}
        <Box>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            options={Location}
            xValue={filterObj.location}
            setValue={(updatedObj) => {
              setFilterObj((prev) => ({
                ...prev,
                location: updatedObj,
              }));
            }}
            objName="location"
            placeholder="Search Branch"
          />
        </Box>

        <Divider />

        {/* Report Type Radios */}
       <FormControl component="fieldset">
  <Typography>Report Options</Typography>

  <RadioGroup
    value={filterObj.reportType}
    onChange={(e) =>
      setFilterObj((prev) => ({
        ...prev,
        reportType: e.target.value,
      }))
    }
  >
    {[
      { value: "SS",  label: "SS Reject Report" },
      { value: "VD",  label: "VD Reject Report" },
      { value: "IL",  label: "IL Reject Report" },
      { value: "MOQ", label: "MOQ Reject Report" },
      { value: "RSP", label: "RSP Reject Report" },
    ].map((option) => (
      <FormControlLabel
        key={option.value}
        value={option.value}
        control={<Radio />}
        label={option.label}
      />
    ))}
  </RadioGroup>
</FormControl>
        {/* View Report Button */}
        <Button
          variant="contained"
          size="small"
          sx={{ mt: "auto" }}
          onClick={handleViewReport}
        >
          View Report
        </Button>
      </Paper>

       {!isMobile && (
        <Paper
          elevation={3}
          sx={{
            flexGrow: 1,
            p: 2,
            height: "90vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Reject Report
          </Typography>

          {reportUrl ? (
            <iframe
              src={reportUrl}
              title="Reject Report"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                overflow: "hidden",
              }}
            />
          ) : (
            <Box
              sx={{
                border: "1px dashed grey",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "text.secondary",
              }}
            >
              Report preview area
            </Box>
          )}
        </Paper>
      )}

      {/* ===== Mobile Full-Screen Modal ===== */}
     {isMobile && (
  <Dialog
    fullScreen
    open={reportModalOpen}
    onClose={() => setReportModalOpen(false)}
  >
    <DialogTitle
      sx={{
        m: 0,
        p: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",        // title left, icon right
        backgroundColor: (theme) => theme.palette.primary.main,
        color: "white",                         // white text
      }}
    >
      <Typography
        variant="h6"
        component="span"
        sx={{ fontWeight: 500, ml: 1 }}
      >
        Report
      </Typography>
      <IconButton
        aria-label="close"
        onClick={() => setReportModalOpen(false)}
        sx={{ color: "white" }}                 // white close icon
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ p: 0 }}>
      {reportUrl ? (
        <iframe
          src={reportUrl}
          title="Reject Report"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
          }}
        />
      ) : (
        <Box
          sx={{
            border: "1px dashed grey",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
          }}
        >
          Report preview area
        </Box>
      )}
    </DialogContent>
  </Dialog>
)}

    </Box>
  );
};

export default RSPRejectReport;